<template>
    <div>
        <v-list dense>
            <template v-for="item in items">
                <v-row
                    v-if="item.heading"
                    :key="item.heading"
                    align="center"
                >
                    <v-col cols="6">
                        <v-subheader v-if="item.heading">
                            {{ item.heading }}
                        </v-subheader>
                    </v-col>
                    <v-col
                    cols="6"
                    class="text-center"
                    >
                        <a
                            href="#!"
                            class="body-2 black--text"
                        >EDIT</a>
                    </v-col>
                </v-row>
                <v-list-group
                    v-else-if="item.children"
                    :key="item.text"
                    v-model="item.model"
                    :prepend-icon="item.model ? item.icon : item['icon-alt']"
                    append-icon=""
                >
                    <template v-slot:activator>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ item.text }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </template>
                    <v-list-item
                    v-for="(child, i) in item.children"
                    :key="i"
                    link
                    :to="{name: item.toUrlName}"
                    exact
                    >
                        <v-list-item-action v-if="child.icon">
                            <v-icon>{{ child.icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ child.text }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>
                <v-list-item
                    v-else
                    :key="item.text"
                    link
                    :to="{name: item.toUrlName}"
                    exact
                >
                    <v-list-item-action>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ item.text }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </template>
        </v-list>

    </div>
</template>

<script>
export default {
    name: 'AppMenu',
    props: {
      source: String,
    },
    data: () => ({
        dialog: false,
        drawer: null,
        items: [
            // { icon: 'mdi-text-box-plus-outline', text: 'Nueva Oferta', toUrlName: 'home' },
            { icon: 'mdi-format-list-bulleted-square', text: 'Ofertas Pendientes', toUrlName: 'ofertasPendientes' },
            { icon: 'mdi-format-list-bulleted-square', text: 'Pedidos Pendientes', toUrlName: 'pedidosPendientes' },
            { icon: 'mdi-magnify', text: 'Histórico Ofertas', toUrlName: 'historicoOfertas' },
        ]
    })
}
</script>